<template>
  <div class="columnlistBox">
    <div v-for="item in columnlist" :key="item.COLUMN_ID" class="column_li">
      <a class="imgBox" :href="'/specialTopicDetail?contentId='+item.SPECIAL_ID" target="_blank">
        <img :src="item.SPECIAL_COVER" alt="">
        <div class="title">
          {{ item.SPECIAL_NAME }}
        </div>
        <div class="abstract">
          <!--{{ item.SPECIAL_ABSTRACT }}-->
        </div>
      </a>
    </div>
  </div>
</template>
<script>

export default {

  props: ['columnlist'],
  data() {
    return {
    }
  },
  methods: {
    goDetail: function(contentId) {
      const { href } = this.$router.resolve({
        path: '/specialTopicDetail',
        name: 'std',
        query: {
          contentId
        }
      })
      window.open(href, '_blank')
    }
  }

}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
    .columnlistBox:after{
      content: "";
      clear: both;
      display: block;
      height: 0;
    }
    .columnlistBox{
        margin-top: 20px;
        .column_li{
          background-color: #fff;
            width: 570px;
            height: 245px;
            display: inline-block;
            float: left;
            margin-right: 56px;
            margin-bottom: 20px;
            border: 1px solid #f0f0f0;
            transition: 0.5s;
          text-align: center;
          &:hover{
            transform: translate(0,-3px);
          }
            &:hover{
                -moz-box-shadow:4px 4px 7px #e8e8e8;
                -webkit-box-shadow:4px 4px 7px #e8e8e8;
                box-shadow:1px 1px 3px #e8e8e8;
            }
            .imgBox{
                width: 550px;
                height: 223px;
                display: inline-block;
                margin-top: 10px;
                position: relative;
                cursor: pointer;
                img{
                    width: 550px;
                    height: 223px;
                }
                .title{
                    position: absolute;
                    top: 100px;
                    color: #ffffff;
                    font-size: 18px;
                    left: 20px;
                }
                .abstract{
                    position: absolute;
                    top: 150px;
                    font-size: 14px;
                    height:50px;
                    color: #666;
                    left: 22px;
                    text-align: left;
                    line-height: 25px;
                    margin-right: 30px;
                    display:-webkit-box;
                    -webkit-line-clamp:2;
                    -webkit-box-orient:vertical;
                    overflow:hidden;
                    word-break: break-all;
                }
            }
        }
      .column_li:nth-child(2n){
        margin-right: 0;
      }

    }
</style>

<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .columnlistBox .column_li .imgBox{
      width: 100%;
      height: auto;
      overflow: hidden;
      img{
        width: 100%;
        height: auto;
      }
    }
    .columnlistBox .column_li .imgBox .title{
      top: 30px;
    }
    .columnlistBox .column_li .imgBox .abstract{
      color: #ffffff;
      top: 72px;
    }
    .columnlistBox {
      background-color: #fff;
      padding: 0 20px;
      width: auto;
      .column_li{
        width: 100%;
        border: none;
        border-bottom: 1px solid #eee;
        overflow: hidden;
        height: auto;
      }
    }
  }
</style>
